module.exports = __webpack_public_path__ + "img/g-digital.6413d107.jpg";